<button class="menu-toggle" [matMenuTriggerFor]="userMenu">{{ initials() }}</button>
<mat-menu #userMenu="matMenu" xPosition="before">
  @if (!isCrstUser()) {
    <button mat-menu-item (click)="passwordReset.emit()">
      <mat-icon class="material-icons-outlined">lock</mat-icon>
      Change Password
    </button>
  }
  <button mat-menu-item (click)="opnDialog()">
    <mat-icon>palette</mat-icon>
    Color scheme
  </button>
  <button mat-menu-item (click)="contactUs.emit()">
    <mat-icon>help</mat-icon>
    Contact Us
  </button>
  <button mat-menu-item (click)="logout.emit()">
    <mat-icon>logout</mat-icon>
    Log out
  </button>
</mat-menu>

<ng-template #colorSchemeDialog>
  <h2 mat-dialog-title>Select your preferred color scheme</h2>
  <mat-dialog-content>
    <mat-radio-group class="d-grid gap-2 py-2" [(ngModel)]="colorMode.selectedScheme">
      <mat-radio-button value="light">Light</mat-radio-button>
      <mat-radio-button value="dark">Dark</mat-radio-button>
      <mat-radio-button value="system">System</mat-radio-button>
    </mat-radio-group>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button matButton mat-dialog-close cdkFocusInitial>Done</button>
  </mat-dialog-actions>
</ng-template>
